<!-- Add or edit task — generated from .appfactory/product-plan.json.
     Name a new task, give it a category, an optional repeat interval and standing notes.

     Regenerated by `appfactory product apply`. Edit the PLAN and re-apply
     rather than editing here. -->
<template>
  <IonPage>
    <IonHeader :translucent="true">
      <IonToolbar>
        <IonTitle>Add or edit task</IonTitle>
        <IonButtons slot="end">
          <IonButton aria-label="Add" @click="goAdd">
            <IonIcon slot="icon-only" :icon="addOutline" />
          </IonButton>
          <IonButton aria-label="Settings" @click="goSettings">
            <IonIcon slot="icon-only" :icon="settingsOutline" />
          </IonButton>
        </IonButtons>
      </IonToolbar>
    </IonHeader>

    <IonContent :fullscreen="true">
      <IonHeader collapse="condense">
        <IonToolbar><IonTitle size="large">Add or edit task</IonTitle></IonToolbar>
      </IonHeader>

      <!-- The empty state is a declared state on this screen in the plan, which
           is why it is here: an app that shows a blank page when it has no data
           reads as broken rather than new.

           A heading, one line, and the control that fixes it — a sentence on
           its own is a shrug, and QA calls it one. This is the screen people
           see FIRST and the one they judge the app by. -->
      <div v-if="!tasks.length" class="empty">
        <h2>Nothing task yet</h2>
        <p>Nothing here yet.</p>
        <IonButton @click="goAdd">Add the first one</IonButton>
      </div>

      <IonList v-else :inset="true">
        <IonItem
          v-for="row in tasks"
          :key="row.id"
          button @click="open(row)"
        >
          <IonLabel>{{ row.name }}</IonLabel>
        </IonItem>
      </IonList>
    </IonContent>
  </IonPage>
</template>

<script setup>
import {
  IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonList, IonItem, IonLabel,
  IonButtons, IonButton, IonIcon,
} from '@ionic/vue';
import { settingsOutline, addOutline } from 'ionicons/icons';
import { tasks } from '../store.js';
import { useRouter } from 'vue-router';

const router = useRouter();
// BY NAME, not by path. The navigation shell decides where a screen is actually
// mounted — bottom-tabs nests every product route under /tabs/ — so a literal
// plan path like `/tasks/1` matches nothing once the shell has it, and the tap
// silently does nothing. A name is the same wherever the route ends up.
const open = (row) => router.push({ name: 'task-detail', params: { id: row.id } });
const goAdd = () => router.push({ name: 'settings' });
const goSettings = () => router.push({ name: 'settings' });
</script>

<style scoped>
.empty { padding: 3rem 1.25rem; text-align: center; color: var(--ion-color-medium); }
.empty h2 { color: var(--ion-text-color); font-size: 1.25rem; margin: 0 0 .5rem; }
.empty p { margin: 0 0 1.5rem; }
</style>
